import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-154f90da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cs-container",
  style: {"min-width":"1400px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-settings" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-sign-out-alt" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-end mb-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold" }, "견적서 리스트")
], -1))
const _hoisted_5 = { class: "w-full h-full flex" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "bg-white border border-line rounded-lg" }
const _hoisted_8 = { class: "flex items-center h-14 px-5 border-b border-line text-placeholder" }
const _hoisted_9 = {
  class: "",
  style: {"min-width":"40px"}
}
const _hoisted_10 = ["checked"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"\" style=\"min-width:110px;\" data-v-154f90da>번호</div><div class=\"w-full\" data-v-154f90da>고객</div><div class=\"\" style=\"min-width:110px;\" data-v-154f90da>모델</div><div class=\"\" style=\"min-width:110px;\" data-v-154f90da>총 수량</div><div class=\"\" style=\"min-width:180px;\" data-v-154f90da>총 비용</div><div class=\"\" style=\"min-width:150px;\" data-v-154f90da>분석결과</div>", 6)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { style: {"min-width":"40px"} }
const _hoisted_19 = ["v-model", "checked", "onClick", "onChange"]
const _hoisted_20 = { class: "flex w-full" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flex fi fi-tr-cubes text-placeholder",
  style: {"font-size":"3.5rem"}
}, null, -1))
const _hoisted_22 = { class: "m-auto ml-4" }
const _hoisted_23 = {
  class: "overflow-hidden mr-5 font-semibold",
  style: {"margin-top":"0.1rem","max-width":"270px"}
}
const _hoisted_24 = {
  class: "overflow-hidden mr-5 text-sm text-desc",
  style: {"margin-top":"0.1rem","max-width":"270px","line-height":"1rem"}
}
const _hoisted_25 = {
  class: "text-sm text-placeholder",
  style: {"margin-top":"0.25rem","line-height":"1rem"}
}
const _hoisted_26 = {
  class: "text-placeholder",
  style: {"min-width":"110px"}
}
const _hoisted_27 = {
  class: "text-placeholder",
  style: {"min-width":"110px"}
}
const _hoisted_28 = {
  class: "font-semibold",
  style: {"min-width":"180px"}
}
const _hoisted_29 = {
  class: "text-placeholder",
  style: {"min-width":"150px"}
}
const _hoisted_30 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-menu-dots text-lightgray" }, null, -1))
const _hoisted_32 = { class: "text-xl text-placeholder" }
const _hoisted_33 = { class: "text-xl text-third font-bold" }
const _hoisted_34 = {
  class: "px-2",
  style: {"min-width":"330px","max-width":"330px"}
}
const _hoisted_35 = { class: "estimate-sticky" }
const _hoisted_36 = { class: "estimate-content overflow-hidden w-full border border-line rounded-md" }
const _hoisted_37 = { class: "flex relative items-center justify-center py-3 px-7 bg-black" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sub-logo",
  src: _imports_0
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-menu-dots-vertical text-white" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "py-6 px-7 bg-white border-b border-line" }
const _hoisted_42 = { class: "font-normal flex justify-between" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-placeholder" }, "전체 견적서", -1))
const _hoisted_44 = { class: "text-right font-semibold1" }
const _hoisted_45 = { class: "mt-8 font-normal flex justify-between" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-placeholder" }, "미확인 견적서", -1))
const _hoisted_47 = { class: "text-right font-semibold1" }
const _hoisted_48 = { class: "mt-8 font-normal flex justify-between" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-placeholder" }, "제출한 견적서", -1))
const _hoisted_50 = { class: "text-right font-semibold1" }
const _hoisted_51 = { class: "py-8 px-7 bg-white" }
const _hoisted_52 = { class: "font-normal flex justify-between" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-1" }, "총 비용", -1))
const _hoisted_54 = { class: "text-right text-4xl text-second font-extrabold" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-right text-lg text-second font-bold" }, " 원", -1))
const _hoisted_56 = { class: "estimate-content-search overflow-hidden1 w-full mt-3 px-6 py-7 border border-line rounded-md bg-white" }
const _hoisted_57 = { class: "mt-5" }
const _hoisted_58 = { class: "relative" }
const _hoisted_59 = {
  key: 1,
  class: "fi fi-rr-calendar-lines text-xl icon-datepicker"
}
const _hoisted_60 = { class: "flex justify-between w-full mt-5 text-left" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rs-memo-circle-check text-2xl" }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-md font-medium" }, "견적서 제출")
], -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rs-trash text-2xl" }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-md font-medium" }, "견적서 삭제")
], -1))
const _hoisted_64 = [
  _hoisted_63
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_context_menu_item = _resolveComponent("context-menu-item")!
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_thumbnail = _resolveComponent("thumbnail")!
  const _component_BasicPagination = _resolveComponent("BasicPagination")!
  const _component_input_search = _resolveComponent("input-search")!
  const _component_vue_datepicker = _resolveComponent("vue-datepicker")!
  const _component_modal_setting = _resolveComponent("modal-setting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_context_menu, {
      show: _ctx.isShowContext,
      options: _ctx.optionsContext
    }, {
      default: _withCtx(() => [
        _createVNode(_component_context_menu_item, { onClick: _ctx.onGoToSetting }, {
          icon: _withCtx(() => [
            _hoisted_2
          ]),
          label: _withCtx(() => [
            _createTextVNode("설정")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_context_menu_item, { onClick: _ctx.onLogout }, {
          icon: _withCtx(() => [
            _hoisted_3
          ]),
          label: _withCtx(() => [
            _createTextVNode("로그아웃")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["show", "options"]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                checked: _ctx.allCheck,
                onChange: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onChangeAllCheck && _ctx.onChangeAllCheck(...args)), ["stop"]))
              }, null, 40, _hoisted_10)
            ]),
            _hoisted_11
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estimates, (estimate) => {
            return (_openBlock(), _createElementBlock("div", {
              key: estimate.id,
              class: "estimate-item",
              onClick: ($event: any) => (_ctx.onGoToEstimate(estimate.id))
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  id: "pating",
                  type: "checkbox",
                  "v-model": estimate.isCheck,
                  checked: estimate.isCheck,
                  onClick: _withModifiers(($event: any) => (1), ["stop"]),
                  onChange: _withModifiers(($event: any) => (_ctx.onChangeEsti(estimate)), ["stop"])
                }, null, 40, _hoisted_19)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["text-desc", [{'estimate-new-badge': !estimate.isRead}, {'estimate-submit-badge': estimate.isActive}]]),
                style: {"min-width":"110px"}
              }, _toDisplayString(estimate.id), 3),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  _createVNode(_component_thumbnail, {
                    size: '3.6rem',
                    url: estimate.thumbnailUrl,
                    defaultIcon: false,
                    customCss: 'w-16 h-16 bg-layout md:w-28 md:h-28',
                    borderWidth: 1,
                    borderColor: '#c0c2c4',
                    round: '5px'
                  }, {
                    "default-icon": _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 2
                  }, 1032, ["url"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(estimate.clientName), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(estimate.clientCompany), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.dateConvertYMDHM(new Date(estimate.createdAt).getTime() / 1000)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, _toDisplayString(estimate.totalCount) + "개", 1),
              _createElementVNode("div", _hoisted_27, _toDisplayString(estimate.totalQuantity) + "개", 1),
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.numberToComma(estimate.buildCost)) + "원", 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", {
                  class: _normalizeClass(["font-semibold", ['analysis-type-' + estimate.modelAnalysis]]),
                  "data-analysis": "pass"
                }, _toDisplayString(_ctx.totalAnalysis(estimate.modelAnalysis)), 3)
              ])
            ], 8, _hoisted_17))
          }), 128))
        ]),
        (_ctx.isShowPaging)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_BasicPagination, {
                "page-count": _ctx.estimateSearchCount,
                "page-range": 5,
                "margin-pages": 1,
                "show-first-last-buttons": false,
                "show-prev-next-buttons": false,
                onPageSelected: _ctx.onPage
              }, {
                breakViewContent: _withCtx(() => [
                  _hoisted_31
                ]),
                pageContent: _withCtx((slotProps) => [
                  _createElementVNode("button", _hoisted_32, _toDisplayString(slotProps.pageNumber), 1)
                ]),
                currentPageContent: _withCtx((slotProps) => [
                  _createElementVNode("button", _hoisted_33, _toDisplayString(slotProps.pageNumber), 1)
                ]),
                _: 1
              }, 8, ["page-count", "onPageSelected"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("button", {
                class: "contextmenu",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onContextMenu($event)))
              }, _hoisted_40)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.numberToComma(_ctx.estimateTotalCount)) + "개", 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.numberToComma(_ctx.estimateUnReadCount)) + "개", 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.numberToComma(_ctx.estimateSubmitCount)) + "개", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.numberToComma(_ctx.estimateTotalCost)), 1),
                  _hoisted_55
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", null, [
              _createVNode(_component_input_search, {
                ref: "search",
                class: "w-full",
                keyword: '',
                onOnSearch: _ctx.onSearch,
                onOnCancel: _ctx.onCancel
              }, null, 8, ["onOnSearch", "onOnCancel"])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_vue_datepicker, {
                  class: "mt-2",
                  lang: "ko",
                  range: "",
                  position: "right",
                  placeholder: "검색 기간을 설정해주세요.",
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDate) = $event)),
                  "date-format": "{ year:'numeric', month:'2-digit', day:'2-digit' }"
                }, null, 8, ["modelValue"]),
                (2 === _ctx.selectedDate.length)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fi fi-br-cross icon-datepicker",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDatePickerClear && _ctx.onDatePickerClear(...args)))
                    }))
                  : (_openBlock(), _createElementBlock("i", _hoisted_59))
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("button", {
                class: "cs-btn cs-pd-btn-xs cs-btn-base",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, _hoisted_62),
              _createElementVNode("button", {
                class: "cs-btn cs-pd-btn-xs cs-btn-danger ml-5",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
              }, _hoisted_64)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isModalSetting)
      ? (_openBlock(), _createBlock(_component_modal_setting, {
          key: 0,
          onOnModalClose: _ctx.onModalClose
        }, null, 8, ["onOnModalClose"]))
      : _createCommentVNode("", true)
  ]))
}